// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-container-gTfpy {
  padding: 0px 32px 20px;
}

.products-toolbar-Bvoyz {
  min-width: 800px;
  height: 56px;
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: space-between;
}

.products-title_container-mf2HX {
  width: 360px;
  flex-grow: 0;
  flex-shrink: 0;
}

.products-title_title-zPHkG {
  font-size: 17px;
}

.products-title_icon-ccv7G {
  --size: 20px;
}

.products-content-zAeir {
  margin-top: 0px;
}

.products-tableHeader_container-alaDY {
  height: 48px;
}

.products-tableHeader_cellContent-fjM07 {
  font-size: 14px;
  color: var(--color-neutral-800);
}
`, "",{"version":3,"sources":["webpack://./src/pages/products/products.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".container {\n  padding: 0px 32px 20px;\n}\n\n.toolbar {\n  min-width: 800px;\n  height: 56px;\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.title_container {\n  width: 360px;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.title_title {\n  font-size: 17px;\n}\n\n.title_icon {\n  --size: 20px;\n}\n\n.content {\n  margin-top: 0px;\n}\n\n.tableHeader_container {\n  height: 48px;\n}\n\n.tableHeader_cellContent {\n  font-size: 14px;\n  color: var(--color-neutral-800);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `products-container-gTfpy`,
	"toolbar": `products-toolbar-Bvoyz`,
	"title_container": `products-title_container-mf2HX`,
	"title_title": `products-title_title-zPHkG`,
	"title_icon": `products-title_icon-ccv7G`,
	"content": `products-content-zAeir`,
	"tableHeader_container": `products-tableHeader_container-alaDY`,
	"tableHeader_cellContent": `products-tableHeader_cellContent-fjM07`
};
export default ___CSS_LOADER_EXPORT___;
